import { BottomSummaryBarV2, SummaryColumn } from '@/components/custom/erp';
import { roundNumber } from '@/lib/formatUtils';

interface BottomBarProps {
  tongSoLuong?: number;
  tongTienNt2?: number;
  tongChietKhau?: number;
  tongThue?: number;
}

export function BottomBar({ tongSoLuong = 0, tongTienNt2 = 0, tongChietKhau = 0, tongThue = 0 }: BottomBarProps) {
  const tongThanhToan = Number(tongTienNt2) - Number(tongChietKhau) + Number(tongThue);

  const columns: SummaryColumn[] = [
    {
      className: 'min-w-[180px]',
      fields: [{ name: 't_so_luong', label: 'Tổng số lượng', value: roundNumber(tongSoLuong, 6), precision: 6 }]
    },
    {
      className: 'min-w-[240px]',
      fields: [
        {
          name: 't_tien_nt2',
          label: 'Tổng tiền',
          value: roundNumber(tongTienNt2 - tongChietKhau, 0),
          inputClassName: 'text-right'
        },
        { name: 't_thue_nt', label: 'Tổng thuế', value: roundNumber(tongThue, 0), inputClassName: 'text-right' }
      ]
    },
    {
      className: 'min-w-[260px]',
      fields: [
        {
          name: 't_tt_nt',
          label: 'Tổng thanh toán',
          value: roundNumber(tongThanhToan, 0),
          inputClassName: 'text-right'
        }
      ]
    }
  ];

  return <BottomSummaryBarV2 columns={columns} />;
}

export default BottomBar;
